// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-and-new-contact-buttons[data-v-1b73e178]{display:flex;flex-direction:column;gap:4px}`, "",{"version":3,"sources":["webpack://./src/views/Contacts.vue"],"names":[],"mappings":"AACA,iDACC,YAAA,CACA,qBAAA,CACA,OAAA","sourcesContent":["\n.import-and-new-contact-buttons {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
